import { render, staticRenderFns } from "./MoblieNotificationMessage.vue?vue&type=template&id=40a97ffc&scoped=true&"
import script from "./MoblieNotificationMessage.vue?vue&type=script&lang=js&"
export * from "./MoblieNotificationMessage.vue?vue&type=script&lang=js&"
import style0 from "./MoblieNotificationMessage.vue?vue&type=style&index=0&id=40a97ffc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a97ffc",
  null
  
)

export default component.exports